import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { ButtonStyleProps } from '../button.type';
import { buttonBase, getButtonSizeClassName, getFocusClassName, getFocusOutlineClassName } from './common.styles';

const TERTIARY = css`
  background: transparent;
  border: none;
  color: ${theme.colors.primary50};
`;

const TERTIARY_DESTRUCTIVE = css`
  background: transparent;
  border: none;
  color: ${theme.colors.status.critical};
`;

const TERTIARY_DISABLED = css`
  &[aria-disabled='true'] {
    background: transparent;
    border-color: ${theme.colors.status.disabled};
    color: ${theme.colors.status.disabled};
  }
`;

const TERTIARY_HOVER = css`
  &:hover:not([aria-disabled='true']) {
    background: ${theme.colors.primary5};
  }
`;

const TERTIARY_DESTRUCTIVE_HOVER = css`
  &:hover:not([aria-disabled='true']) {
    background: ${theme.colors.critical5};
  }
`;

const TERTIARY_PRESSED = css`
  &:active:not([aria-disabled='true']) {
    background: ${theme.colors.primary5};
    color: ${theme.colors.primary70};

    svg {
      color: ${theme.colors.primary70};
    }
  }
`;

const TERTIARY_DESTRUCTIVE_PRESSED = css`
  &:active:not([aria-disabled='true']) {
    background: ${theme.colors.critical10};
    color: ${theme.colors.critical70};

    svg {
      color: ${theme.colors.critical70};
    }
  }
`;

const TERTIARY_LOADING = css`
  background: transparent;

  &[aria-disabled='true'] {
    box-shadow: none;
    color: ${theme.colors.status.disabled};
  }
`;

export const tertiaryClassName = ({
  size,
  iconOnly,
  destructive,
  showFocusOutline,
  isLoading,
}: Pick<ButtonStyleProps, 'size' | 'iconOnly' | 'destructive' | 'showFocusOutline' | 'isLoading'>) => {
  const tertiaryBtnClasses = destructive
    ? {
        focus: 'critical' as const,
        variant: TERTIARY_DESTRUCTIVE,
        hover: TERTIARY_DESTRUCTIVE_HOVER,
        pressed: TERTIARY_DESTRUCTIVE_PRESSED,
      }
    : {
        focus: 'primary' as const,
        variant: TERTIARY,
        hover: TERTIARY_HOVER,
        pressed: TERTIARY_PRESSED,
      };

  return cx(
    buttonBase,
    getButtonSizeClassName(size ?? 'small', iconOnly),
    getFocusClassName(tertiaryBtnClasses.focus),
    showFocusOutline ? getFocusOutlineClassName(tertiaryBtnClasses.focus) : null,
    tertiaryBtnClasses.variant,
    !isLoading && TERTIARY_DISABLED,
    isLoading ? TERTIARY_LOADING : tertiaryBtnClasses.hover,
    !isLoading && tertiaryBtnClasses.pressed
  );
};
